export const googleIcon = "/static/images/google-icon.svg";
